import { load, save } from './storage.js';

/** ISO-Jahr und -KW zu einem Datum (YYYY-MM-DD). */
export function jahrKw(iso) {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + 3 - ((d.getUTCDay() + 6) % 7)); // Donnerstag der Woche
  const jahr = d.getUTCFullYear();
  const kw = 1 + Math.floor((d - Date.UTC(jahr, 0, 4)) / 604_800_000 + (((new Date(Date.UTC(jahr, 0, 4)).getUTCDay() + 6) % 7) / 7));
  return { jahr, kw };
}

/**
 * Eingereichte Wochen, die sich dieses Gerät gemerkt hat ({ 'JJJJ-KW': ISO-Zeit }) – nur für die Uhrzeit im Hinweis und
 * als Rückfall, solange der Exxas-Stand der Woche noch nicht geladen ist. Massgebend ist `status` aus Exxas (siehe istGesperrt).
 */
const KEY = 'eingereicht';
const schluessel = ({ jahr, kw }) => `${jahr}-${kw}`;
export const eingereichtAm = (woche) => load(KEY, {})[schluessel(woche)] ?? null;
export function eingereichtMerken(woche, am) { save(KEY, { ...load(KEY, {}), [schluessel(woche)]: am }); }
export function eingereichtVergessen(woche) {
  const alle = { ...load(KEY, {}) };
  delete alle[schluessel(woche)];
  save(KEY, alle);
}

/**
 * Ist die Woche eingereicht und damit für die Zeiterfassung gesperrt? Exxas schreibt `status` erst beim Einreichen;
 * kennt die App den Exxas-Stand (`stand.status` vorhanden, auch null), gilt er. Sonst das, was dieses Gerät eingereicht hat.
 */
export function istGesperrt(stand, woche) {
  if (stand && stand.status !== undefined) return !!stand.eingereicht;
  return !!eingereichtAm(woche);
}
